module.exports = __webpack_public_path__ + "img/gogoresto.af8f8ce4.png";